function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m6 8 1.422-6.223A1 1 0 0 1 8.397 1H9a2 2 0 0 1 2 2v3.7l5.359-.536A1.493 1.493 0 0 1 17.143 9h.357a1.5 1.5 0 0 1 0 3h-1a1.5 1.5 0 0 1 0 3h-.384a1.494 1.494 0 0 1-.745 2.852L6 17H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3Z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgThumbsUp;